import React from 'react'
import { Link } from 'react-router-dom'
import './LandingPageFooter.css'

import digipalzWhiteLogo from '../../../assets/LandingPage/Digipalz_wh.png'
import { FaLinkedinIn, FaTiktok } from 'react-icons/fa'

const LandingPageFooter = () => {
  return (
    <footer className='digipalz-landing-footer__background'>
      <div className='digipalz-landing-footer__content-wrapper'>
        <div className='digipalz-landing-footer__brand-info'>
          <div className='digipalz-landing-footer__logo-container'>
            <img
              className='digipalz-landing-footer__logo-icon'
              alt='Footer logo'
              src='/assets/footer-logo.png'
              loading='lazy'
              decoding='async'
            />
            <img
              className='digipalz-landing-footer__logo-text'
              alt='Digipalz white logo'
              src={digipalzWhiteLogo}
              loading='lazy'
              decoding='async'
            />
          </div>

          <p className='digipalz-landing-footer__brand-description'>
            Protecting children in the digital world through gamified learning.
          </p>
        </div>

        <div className='digipalz-landing-footer__links-wrapper'>
          {/* Quick Links Column */}
          <div className='digipalz-landing-footer__links-column'>
            <div className='digipalz-landing-footer__section-title'>
              Quick Links
            </div>
            <Link
              to='/'
              className='digipalz-landing-footer__nav-link digipalz-landing-footer__nav-link--clickable'
            >
              Home
            </Link>
            <Link
              to='/educator-landing'
              className='digipalz-landing-footer__nav-link digipalz-landing-footer__nav-link--clickable'
            >
              Educators
            </Link>
            <Link
              to='/pricing'
              className='digipalz-landing-footer__nav-link digipalz-landing-footer__nav-link--clickable'
            >
              Pricing
            </Link>
            <Link
              to='/blog'
              className='digipalz-landing-footer__nav-link digipalz-landing-footer__nav-link--clickable'
            >
              Blog
            </Link>
            <Link
              to='/contact-us'
              className='digipalz-landing-footer__nav-link digipalz-landing-footer__nav-link--clickable'
            >
              Contact Us
            </Link>
            {/* <div
              className='digipalz-landing-footer__nav-link digipalz-landing-footer__nav-link--clickable'
              onClick={handleAboutUsRedirect}
            >
              About Us
            </div> */}
            {/* <div
              className='digipalz-landing-footer__nav-link digipalz-landing-footer__nav-link--clickable'
              onClick={handleFaqsRedirect}
            >
              Help Center
            </div> */}
          </div>

          {/* Legal Column */}
          <div className='digipalz-landing-footer__links-column'>
            <div className='digipalz-landing-footer__section-title'>Legal</div>
            <a
              href='/privacy-policy-en'
              target='_blank'
              rel='noopener noreferrer'
              className='digipalz-landing-footer__legal-link digipalz-landing-footer__legal-link--clickable'
            >
              Privacy Policy
            </a>
            <a
              href='/children-privacy-policy-en'
              target='_blank'
              rel='noopener noreferrer'
              className='digipalz-landing-footer__legal-link digipalz-landing-footer__legal-link--clickable'
            >
              Children&apos;s Privacy Policy
            </a>
            <a
              href='/terms-of-service-en'
              target='_blank'
              rel='noopener noreferrer'
              className='digipalz-landing-footer__legal-link digipalz-landing-footer__legal-link--clickable'
            >
              Terms of Service
            </a>
            <a
              href='/cookie-policy-en'
              target='_blank'
              rel='noopener noreferrer'
              className='digipalz-landing-footer__legal-link digipalz-landing-footer__legal-link--clickable'
            >
              Cookie Policy
            </a>
            <a
              href='/data-retention-policy-en'
              target='_blank'
              rel='noopener noreferrer'
              className='digipalz-landing-footer__legal-link digipalz-landing-footer__legal-link--clickable'
            >
              Data Retention Policy
            </a>
            <a
              href='/accessibility'
              target='_blank'
              rel='noopener noreferrer'
              className='digipalz-landing-footer__legal-link digipalz-landing-footer__legal-link--clickable'
            >
              Accessibility Statement
            </a>
            {/* <div
              className='digipalz-landing-footer__legal-link digipalz-landing-footer__legal-link--clickable'
              onClick={handleCookieSettingsClick}
            >
              Cookie Settings
            </div> */}
          </div>

          {/* Follow Us Column */}
          <div className='digipalz-landing-footer__links-column'>
            <div className='digipalz-landing-footer__section-title'>
              Follow Us
            </div>
            <div className='landing-page-social-media-icons'>
              <a
                href='https://www.linkedin.com/company/digipalz'
                target='_blank'
                rel='noopener noreferrer'
                className='digipalz-landing-footer__social-wrapper digipalz-landing-footer__social-wrapper--clickable'
                aria-label='LinkedIn'
              >
                <FaLinkedinIn
                  className='digipalz-landing-footer__social-icon'
                  aria-hidden='true'
                  focusable='false'
                />
              </a>
              <a
                href='https://www.tiktok.com/@digipalz.io?_r=1&_t=ZS-92TQCqkw2Qa'
                target='_blank'
                rel='noopener noreferrer'
                className='digipalz-landing-footer__social-wrapper digipalz-landing-footer__social-wrapper--clickable'
                aria-label='TikTok'
              >
                <FaTiktok
                  className='digipalz-landing-footer__social-icon'
                  aria-hidden='true'
                  focusable='false'
                />
              </a>
              {/* <div
                className='digipalz-landing-footer__social-wrapper digipalz-landing-footer__social-wrapper--clickable'
                onClick={handleLinkedInRedirect}
              >
                <FaInstagram className='digipalz-landing-footer__social-icon' />
              </div>
              <div
                className='digipalz-landing-footer__social-wrapper digipalz-landing-footer__social-wrapper--clickable'
                onClick={handleLinkedInRedirect}
              >
                <FaTwitter className='digipalz-landing-footer__social-icon' />
              </div>
              <div
                className='digipalz-landing-footer__social-wrapper digipalz-landing-footer__social-wrapper--clickable'
                onClick={handleLinkedInRedirect}
              >
                <FaYoutube className='digipalz-landing-footer__social-icon' />
              </div> */}
            </div>
          </div>
        </div>
      </div>

      <p className='digipalz-landing-footer__copyright-text'>
        © {new Date().getFullYear()} Digipalz<sup>™</sup> Corp. All rights
        reserved.
      </p>
    </footer>
  )
}

export default LandingPageFooter
